export class Facultad {
  Id: string | null;
  Name: string;

  constructor() {
    this.Id = null;
    this.Name = '';
  }
}
